"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Calendar } from "lucide-react";
function EventsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-48 rounded-lg bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p>Unable to load upcoming events. Please try again later.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        <p>No upcoming events or classes at this time. Check back soon!</p>
      </div>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {displayPosts.map((post, i) => {
      const isClass = post.title.toLowerCase().includes("class") || post.title.toLowerCase().includes("create the plate");
      const buttonLabel = isClass ? "Enroll" : "Get Tickets";
      return <article key={post.id} data-index={i} className="group flex flex-col gap-4 rounded-lg border border-border bg-background p-5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:bg-muted-light-background hover:shadow-medium">
            <div className="flex gap-4">
              {post.featuredImage && <div className="shrink-0">
                  <img src={post.featuredImage} alt={post.title} className="size-20 rounded-md object-cover" />
                </div>}
              
              <div className="flex-1 min-w-0">
                {post.date && <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                    <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                    <time dateTime={post.date}>
                      {new Date(post.date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric"
                })}
                    </time>
                  </div>}
                
                <h3 className="font-display text-lg font-semibold text-foreground leading-tight line-clamp-2">
                  {post.title}
                </h3>
              </div>
            </div>

            {post.excerpt && <p className="text-sm text-muted-foreground line-clamp-2">
                {post.excerpt.replace(/<[^>]*>/g, "")}
              </p>}

            <div className="mt-auto">
              <Button asChild variant="default" size="sm" className="w-full transition-transform duration-[120ms] ease-[var(--ease-spring)] hover:scale-[1.04]">
                <Link to={post.link || "#"}>
                  {buttonLabel}
                </Link>
              </Button>
            </div>
          </article>;
    })}
    </div>;
}
export default function UpcomingEventsClasses() {
  return <section id="upcoming-events-classes" className="px-6 py-16 md:py-20 bg-background">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground md:text-4xl mb-3">
            Upcoming Events & Classes
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Join us for intimate dining experiences and hands-on cooking classes in Los Angeles
          </p>
        </div>

        <PostsProvider className="events-grid-container" wp_query={{
        per_page: 3,
        order: "asc",
        orderby: "date",
        status: ["publish"]
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "date", "link", "_embedded", "_links.wp:featuredmedia"]}>
          <EventsGrid />
        </PostsProvider>
      </div>
    </section>;
}